<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :width="225"
      app
    >
      <v-list dense shaped>
        <template v-for="item in mainMenu">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
            sub-group=""
          >
            <template v-slot:activator>
              <v-list-item-content >
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.router"
              @click="clickChildMobileMenu(child)"
            >
              <!-- <v-list-item-action v-if="child.icon">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <img v-on="on" :src="require('@/assets/MenuIcons/' + child.icon + '.png')" height="30"/>
                  </template>
                  <span>{{ child.text }}</span>
                </v-tooltip>
              </v-list-item-action> -->
              <v-list-item-content>
                <v-list-item-title
                >
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
            :to="item.router"
            @click="clickMobileMenu(item.id)"
          >
            <!-- <v-list-item-action>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <img v-on="on" :src="require('@/assets/MenuIcons/' + item.icon + '.png')" height="30"/>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-action> -->
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-card id="lateral">
      <v-toolbar
        dark
        tabs
        flat
        :color="mainMenuColor"
      >
        <v-app-bar-nav-icon @click="mini=false" @click.stop="drawer = !drawer" v-show="$vuetify.breakpoint.mdAndDown"/>
        <v-toolbar-title> {{ companyName }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <a v-if="companyFacebook" target="_blank" rel="noopener noreferrer" :href="'https://' + companyFacebook">
          <v-img 
            min-height="24" 
            max-height="24"
            min-width="24"
            max-width="24"
            src="@/assets/icons/facebook.png"
            
          ></v-img>
        </a>
        <a v-if="companyInstagram" class="px-3" target="_blank" rel="noopener noreferrer" :href="'https://' + companyInstagram">
          <v-img 
            min-height="24" 
            max-height="24"
            min-width="24"
            max-width="24"
            src="@/assets/icons/instagram.png"
            
          ></v-img>
        </a>
        <a v-if="companyYoutube" target="_blank" rel="noopener noreferrer" :href="'https://' + companyYoutube">
          <v-img 
            min-height="24" 
            max-height="24"
            min-width="24"
            max-width="24"
            src="@/assets/icons/youtube.png"
            
          ></v-img>
        </a>
        <v-btn icon color="red" @click="openFavoritesForm = true">
          <v-icon>favorite</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs
            v-model="tabs"
            align-with-title
            v-if="$vuetify.breakpoint.lgAndUp"
          >
            <v-tab class="text-capitalize" to="/inicio">Início</v-tab>
            <v-menu 
              offset-y
              open-on-hover
              close-on-click
              rounded="b-xl"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tab 
                  v-bind="attrs"
                  v-on="on" 
                  class="text-capitalize"
                  href="#for"
                >
                  Comprar
                </v-tab>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in menuBuyItems"
                  :key="i"
                  @click="clickBuyMenu(item)"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu 
              offset-y
              open-on-hover
              close-on-click
              rounded="b-xl"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tab 
                  v-bind="attrs"
                  v-on="on" 
                  class="text-capitalize"
                  href="#for"
                >
                  Alugar
                </v-tab>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in menuBuyItems"
                  :key="i"
                  @click="clickRentMenu(item)"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tab class="text-capitalize" @click="openRegisterImmobile()">Negocie Seu imóvel</v-tab>
            <v-tab class="text-capitalize" to="/financiamento">Financimento</v-tab>
            <v-tab class="text-capitalize" @click="openContactUs()">Fale conosco</v-tab>
            <v-tab class="text-capitalize" to="/quem_somos">Quem somos</v-tab>
            <v-tabs-slider color="pink"></v-tabs-slider>
          </v-tabs>
        </template>
      </v-toolbar>
      <ContactUsForm :open="openContactUsForm" @closeContactUsForm="openContactUsForm = false" />
      <FavoritesForm :open="openFavoritesForm" @closeFavoritesForm="openFavoritesForm = false" />
      <RegisterImmobileForm :open="openRegisterImmobileForm" @closeRegisterImmobileForm="openRegisterImmobileForm = false" />
    </v-card>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import apiState from '@/ilios.store';
import ContactUsForm from '@/components/Global/ContactUsForm';
import RegisterImmobileForm from '@/components/Global/RegisterImmobileForm';
import FavoritesForm from '@/components/Global/FavoritesForm';

export default {
  name: 'MainMenu',

  components: {
    ContactUsForm,
    RegisterImmobileForm,
    FavoritesForm,
  },

  data: () => ({
    openFavoritesForm: false,
    openContactUsForm: false,
    openRegisterImmobileForm: false,
    tabs: null,
    drawer: false,
    mini: true,
    menuBuyItems: [
      {id: 1, name: "Casa"}, 
      {id: 2, name: "Kitnet"}, 
      {id: 3, name: "Sobrado"}, 
      {id: 4, name: "Apartamento"}, 
      {id: 5, name: "Sobreloja"}, 
      {id: 6, name: "Terreno"},
      {id: 7, name: "Sala"}, 
      {id: 8, name: "Loja"}
    ],
    mainMenu: [
      { id: 1, text: 'Inicio', router: '/inicio' },
      {
        id: 2,
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Comprar',
        model: false,
        router: '',
        children: [
          {id: 1, text: "Casa", type: 'buy'}, 
          {id: 2, text: "Kitnet", type: 'buy'}, 
          {id: 3, text: "Sobrado", type: 'buy'}, 
          {id: 4, text: "Apartamento", type: 'buy'}, 
          {id: 5, text: "Sobreloja", type: 'buy'}, 
          {id: 6, text: "Terreno", type: 'buy'},
          {id: 7, text: "Sala", type: 'buy'}, 
          {id: 8, text: "Loja", type: 'buy'}
        ],
      },
      {
        id: 3,
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'Alugar',
        model: false,
        router: '',
        children: [
          {id: 1, text: "Casa", type: 'rent'}, 
          {id: 2, text: "Kitnet", type: 'rent'}, 
          {id: 3, text: "Sobrado", type: 'rent'}, 
          {id: 4, text: "Apartamento", type: 'rent'}, 
          {id: 5, text: "Sobreloja", type: 'rent'}, 
          {id: 6, text: "Terreno", type: 'rent'},
          {id: 7, text: "Sala", type: 'rent'}, 
          {id: 8, text: "Loja", type: 'rent'}
        ],
      },
      { id: 4, text: 'Negocie seu Imóvel', router: '' },
      { id: 5, text: 'Financiamento', router: '/financiamento' },
      { id: 6, text: 'Fale Conosco', router: '' },
      { id: 7, text: 'Quem Somos', router: '/quem_somos' },
    ],
  }),

  mounted() {

  },

  computed: {
    ...mapState('Company',{
      companyName: 'companyName',
      companyFacebook: 'companyFacebook',
      companyInstagram: 'companyInstagram',
      companyYoutube: 'companyYoutube',
      mainMenuColor: 'mainMenuColor',
    }),
  },

  watch: {

  },

  methods: {
    ...mapActions({
      setBuyMenuValue: 'Immobile/setBuyMenuValue',
      setRentMenuValue: 'Immobile/setRentMenuValue',
    }),

    ...mapGetters({
  
    }),

    async clickBuyMenu(objMenuId){
      await this.setBuyMenuValue({
        menuId: objMenuId
      })
      if (!(this.$router.currentRoute.path === '/inicio')) {
        this.$router.push('/inicio');
      }
    },

    async clickRentMenu(objMenuId){
      await this.setRentMenuValue({
        menuId: objMenuId
      })
      if (!(this.$router.currentRoute.path === '/inicio')) {
        this.$router.push('/inicio');
      }
    },

    openContactUs(){
      this.openContactUsForm = true
    },

    openRegisterImmobile(){
      this.openRegisterImmobileForm = true
    },

    clickMobileMenu(id){
      switch (id) {
        case 4:
          this.openRegisterImmobile()
          break;
        case 6:
          this.openContactUs()
          break;
      }
    },

    clickChildMobileMenu(obj){
      switch (obj.type) {
        case 'buy':
          this.clickBuyMenu(obj)
          break;
        case 'rent':
          this.clickRentMenu(obj)
          break;
      }
    }
  },
};
</script>

<style>
  #lateral .v-btn--example {
    bottom: 0;
    position: absolute;
    margin: 0 0 16px 16px;
  }
</style>